const flags = {
  APP_MODERNISATION: "APP_MODERNISATION",
  WEB_MODERNISATION: "WEB_MODERNISATION",
  FORCE_APP_MODE: "FORCE_APP_MODE",
  ENHANCED_SEARCH: "ENHANCED_SEARCH",
  B2C_DISABLE_AUTH: "B2C_DISABLE_AUTH",
  ENHANCED_COUNTER: "ENHANCED_COUNTER",
  ENHANCED_BROWSER_HISTORY_BUTTON: "ENHANCED_BROWSER_HISTORY_BUTTON",
};

export default Object.freeze(flags);
